module.exports = __webpack_public_path__ + "img/ls.44bb04f.svg";